import { Grid, Icon, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, Switch } from "@material-ui/core";
import { LabelledEventRow } from "./Water/LabelledEventRow";
import IReviewedEvent from "../models/ReviewedEvent";
import { useState, useEffect } from "react";
import { IReviewer, ReviewStatus } from "../models/IReviewer";
import { useAuthDataContext } from "./AuthDataProvider";
import { CompletedReviewButton } from "./CompletedReviewButton";
import SentreeEventTypes from "../models/Sentree/SentreeEventTypes";

interface ILabelledEventsProps {
    taggedEvents: (IReviewedEvent | null)[];
    eventId: string;
    reviewers: IReviewer[];
    dataScience: boolean;
    archived: boolean;
    completedCallback: (arg0: ReviewStatus) => void;
    eventType: string;
}

export const LabelledEvents = (props: ILabelledEventsProps) => {
    const { user } = useAuthDataContext();

    const [taggedEvents, setTaggedEvents] = useState<(IReviewedEvent | null)[]>([]);
    const [reviewOpen, setReviewOpen] = useState<boolean>(false);
    const [isSteadyState, setIsSteadyState] = useState(false);


    useEffect(() => {
        setTaggedEvents(props.taggedEvents);
        for (const ev of props.taggedEvents) {
            if (ev?.eventType === SentreeEventTypes.steadyState) {
                setIsSteadyState(true);
                return;
            }
        }
        setIsSteadyState(false);
    }, [props.taggedEvents]);

    const addRow = () => {
        setTaggedEvents([...taggedEvents, null])
    }


    useEffect(() => {
        if(props.archived){
            setReviewOpen(false)
        }else{
        for (const reviewer of props?.reviewers) {
            if (reviewer.reviewer === user?.user_details.user_id) {
                setReviewOpen(reviewer.status === ReviewStatus.inProgress) 
                break;
            }
        }
    }
    }, [props, user]);

    const closeReview = (status: ReviewStatus) => {
        setReviewOpen(false);
        props.completedCallback(status);
    }

    return (
        <Grid item xs={12} md={12} lg={12}>
            <div>
                <span style={{ float: 'right' }}>
                    <Grid container alignItems="center">
                        <Grid item>Steady State Mode</Grid>
                        <Grid item>
                            <Switch
                                checked={isSteadyState}
                                onChange={e => setIsSteadyState(e.target.checked)}/>
                        </Grid>
                    </Grid>
                </span>
                <h2>{props.dataScience ? "Data Science" : props.eventType + " Expert"} Labelled Events</h2>
            </div>

            <Paper className="paper">
                {reviewOpen ?
                    <IconButton style={{ float: "right" }} onClick={() => addRow()}>
                        <Icon>add_circle_icon</Icon>
                    </IconButton> : null
                }
                <Table classes={{ root: "reactivetable" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Event Start</TableCell>
                            <TableCell>Event End</TableCell>
                            <TableCell>Event Height</TableCell>
                            {!isSteadyState ? <TableCell>Event Type</TableCell> : null}
                            <TableCell>{!isSteadyState ? "Event Subtype" : "SS Type"}</TableCell>
                            {isSteadyState ? <TableCell>Stage</TableCell> : null}
                            <TableCell>Event Comment</TableCell>
                            <TableCell>Confidence Level</TableCell>
                            <TableCell>User</TableCell>
                            {reviewOpen ? <TableCell>Edit</TableCell> : null}
                            {reviewOpen ? <TableCell>Delete</TableCell> : null}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {taggedEvents.map((event, i) => (
                            <LabelledEventRow
                                key={i}
                                taggedEvent={event}
                                eventId={props.eventId}
                                editable={reviewOpen}
                                dataScience={props.dataScience}
                                eventTypes={props.eventType}
                                steadyStateMode={isSteadyState}/>)
                        )}
                    </TableBody>
                </Table>
            </Paper>
            {reviewOpen ?
                <CompletedReviewButton eventId={props.eventId} dataScience={props.dataScience} discard={false} completedCallback={closeReview} /> : null
            }
            {props.dataScience && reviewOpen ?
                <CompletedReviewButton eventId={props.eventId} dataScience={props.dataScience} discard={true} completedCallback={closeReview} /> : null
            }
        </Grid >
    )
}